<template>
  <div
    id="footer"
    class="fixed bottom-0 bg-gray-100 w-full border-t border-solid border-gray-200 opacity-100 py-2"
    style="left:0"
  >
    <div class="md:ml-72 flex flex-row px-4 justify-between items-center">
      <div
        v-if="!disabled"
        class="text-sm font-semibold flex flex-row items-center "
      >
        Allow Multiple Answers
        <svg-icon
          icon="heroicons/solid/question-mark-circle"
          class="h-5 w-5 my-auto mx-2 text-gray-500"
          v-tooltip="
            'Allow users to select more than one <br/> answer choice for this question.'
          "
        />
        <BaseToggle v-model="allowMany" class="h-6 my-auto" />
      </div>

      <div v-else class="text-sm font-semibold flex flex-row items-center opacity-60">
        Allow Multiple Answers:
        <svg-icon
          icon="heroicons/solid/question-mark-circle"
          class="h-5 w-5 my-auto mx-2 text-gray-500"
        />
        <BaseToggle :disabled="disabled" class="h-6 my-auto" />
      </div>

      <!-- Step pager -->

      <nav class="block flex items-center">
        <draggable
          v-model="steps"
          class="flex flex-wrap my-auto"
          :disabled="!reorderSteps"
        >
          <div v-for="(step, index) of steps" :key="index">
            <div
              v-tooltip="
                !reorderSteps ? 'Go to step ' + parseInt(index + 1) : ''
              "
              class="flex h-8 w-8 cursor-pointer first:ml-0 text-xs font-semibold mx-1 p-0 rounded-full items-center justify-center leading-tight relative border border-solid border-purple-500 "
              :class="pagerClass(index)"
              @click="$emit('select-step', index)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </draggable>

        <div v-if="!reorderSteps" @click="reorderSteps = !reorderSteps">
          <svg-icon
            icon="heroicons/solid/refresh"
            class=" text-xs font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-gray-300 hover:text-purple-700 cursor-pointer"
            v-tooltip="!reorderSteps ? 'Re-order steps ' : 'Done re-ordering'"
          />
        </div>

        <div v-else class="flex flex-row items-center justify-center">
          <div class="text-sm my-auto text-gray-500">
            Drag step to re-order
          </div>
          <button
            @click="reorderSteps = !reorderSteps"
            class="block bg-gray-600 hover:bg-gray-700 text-white font-bold uppercase text-xs px-4 py-1 mr-5 rounded outline-none focus:outline-none m-1"
            type="button"
          >
            Done Re-ordering
          </button>
        </div>
      </nav>

      <!--End Pagination -->

      <nav class="block ml-24">
        <ul class="flex pl-0 rounded list-none flex-wrap">
          <li>
            <div @click="$emit('clone-step')">
              <svg-icon
                icon="heroicons/outline/duplicate"
                class=" text-xs font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-gray-300 hover:text-purple-700 cursor-pointer"
                v-tooltip="'Clone current step'"
              />
            </div>
          </li>

          <li>
            <div @click="$emit('confirm-delete')">
              <svg-icon
                icon="heroicons/outline/x-circle"
                class="text-xs font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-gray-300 hover:text-purple-700 cursor-pointer"
                v-tooltip="'Delete current step'"
              />
            </div>
          </li>

          <li>
            <BaseDropDown
              v-on:add-step="remit"
              v-bind:items="[
                {
                  event: 'add-step',
                  args: 'image',
                  label: 'Image Choice',
                  icon: 'heroicons/outline/photograph',
                },
                {
                  event: 'add-step',
                  label: 'Welcome Page',
                  args: 'welcome',
                  icon: 'heroicons/outline/emoji-happy',
                },
                {
                  event: 'add-step',
                  args: 'end',
                  label: 'Thank you Page',
                  icon: 'heroicons/outline/check-circle',
                },
              ]"
            >
              <template v-slot:button>
                <svg-icon
                  icon="heroicons/outline/plus-circle"
                  class="text-xs font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-gray-300 hover:text-purple-700 cursor-pointer"
                  v-tooltip="'Add a new step'"
                />
              </template>

              <template v-slot:header>
                <div class="text-sm font-semibold py-2 px-4 mx-auto">
                  ADD A STEP
                </div>
                <div class="border border-solid border-gray-200"></div>
              </template>
            </BaseDropDown>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import Step from "@/models/Step";
export default {
  components: { Draggable },
  props: ["survey", "step", "currentStep", "saving"],
  data() {
    return {
      reorderSteps: false,
    };
  },
  computed: {
    disabled() {
      //disable option panel on welcome page and thank you page
      return this.step.type == "welcome" || this.step.type == "end";
    },
    steps: {
      get() {
        return this.survey.steps;
      },
      set(steps) {
        var reorderedList = Step.reIndexList(steps);
        Step.update({
          data: reorderedList,
        });
      },
    },
    allowMany: {
      get() {
        return this.step.allow_many;
      },
      set(value) {
        console.log("allowmany value: " + value);
        if (value !== this.step.allow_many) {
          Step.update({ where: this.step.id, data: { allow_many: value } });
        }
      },
    },
  },
  methods: {
    pagerClass(index) {
      if (this.reorderSteps)
        return "text-purple-600 bg-white border border-dashed border-purple-400 cursor-move";
      else if (index == this.currentStep)
        return "text-white bg-purple-600 border border-transparenet";
      else
        return "text-purple-600 bg-white hover:bg-purple-100 border border-transparent";
    },
    remit(type) {
      this.$emit("add-step", type);
    },
  },
};
</script>

<style></style>
